import type { ReactNode } from 'react'

import type { CSSProperties } from 'styled-components'

import { Arrow } from './Arrow'
import { Container } from './Container'
import { Location } from './Location'
import { Wrapper } from './Wrapper'

type Props = {
	children: ReactNode
	location?: Location
	show?: boolean
	tip: ReactNode
	/** In milliseconds */
	transitionInDelay?: number
	/** In milliseconds */
	transitionDuration?: number
	/** Sets the `max-width` of the tooltip container */
	maxWidth?: number

	style?: CSSProperties
	className?: string
}

export const Tooltip = ({
	tip,
	show = true,
	location = Location.Top,
	children,
	transitionInDelay = 300,
	transitionDuration = 200,
	maxWidth = 300,
	style,
	className,
}: Props) => (
	<Wrapper id='tooltip-wrapper' style={style} className={className}>
		{show && (
			<Container location={location} transitionInDelay={transitionInDelay} maxWidth={maxWidth}>
				{tip}
			</Container>
		)}
		{children}
		{show && <Arrow location={location} transitionDuration={transitionDuration} />}
	</Wrapper>
)

export { Location }
